export default __webpack_public_path__ + "static/media/2023_März_Regenbogen.de13a860.webp";